import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { RemoteApiError } from "../useRemote/types";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";

/**
 * Deletes a blocking event (DELETE /fleet/blocking-events/:id).
 * Use mutateAsyncSafe when calling from UI so errors are handled in the hook and the promise never rejects.
 */
export function useRemoteDeleteBlockingEvent() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useRemoteMutation<void, RemoteApiError, number>({
    key: ["fleet", "delete-blocking-event"],
    url: id => `/fleet/blocking-events/${id}`,
    method: "delete",
    snackbarTextOnSuccess: t("Blocking event deleted"),
    onSuccess: () => {
      queryClient.invalidateQueries(["fleet", "vehicles"]);
      queryClient.invalidateQueries(["fleet", "blocking-events"]);
    }
  });
}
